import { render, staticRenderFns } from "./RightLeader.vue?vue&type=template&id=ffd6ebc4&scoped=true"
import script from "./RightLeader.vue?vue&type=script&lang=js"
export * from "./RightLeader.vue?vue&type=script&lang=js"
import style0 from "./RightLeader.vue?vue&type=style&index=0&id=ffd6ebc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd6ebc4",
  null
  
)

export default component.exports